import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { User } from '../../../interfaces/user.interface';
import { GetMeUserResponse } from '../interfaces/get-me-user';
import { userMapper } from '../../../mappers/userMapper';

export interface MeState {
  user: User | null;
  errorCode: number | null;
}

const initialState: MeState = {
  user: null,
  errorCode: null,
};

const meSlice = createSlice({
  name: 'me',
  initialState,
  reducers: {
    getMeUserInitApiAction: (state) => {
      state.errorCode = null;
    },
    getMeUserSuccessApiAction: (state, action: PayloadAction<GetMeUserResponse>) => {
      state.user = userMapper.mapResponseToUser(action.payload);
    },
    getMeUserFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putMeUserInitApiAction: (state) => {
      state.errorCode = null;
    },
    putMeUserSuccessApiAction: () => {},
    putMeUserFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putMePasswordInitApiAction: (state) => {
      state.errorCode = null;
    },
    putMePasswordSuccessApiAction: () => {},
    putMePasswordFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    meClearAction: (state) => {
      state.user = null;
      state.errorCode = null;
    },
  },
});

export const {
  getMeUserInitApiAction,
  getMeUserSuccessApiAction,
  getMeUserFailureApiAction,
  putMeUserInitApiAction,
  putMeUserSuccessApiAction,
  putMeUserFailureApiAction,
  putMePasswordInitApiAction,
  putMePasswordSuccessApiAction,
  putMePasswordFailureApiAction,
  meClearAction,
} = meSlice.actions;

export default meSlice.reducer;
